import React from "react";
import { memo, useCallback } from "react";
import _ from "lodash";
import { Button, Input, Select, Popconfirm, Switch } from "antd";
import PaginationComponent from "../PaginationComponent";
import { FaPencilAlt } from "react-icons/fa";
import { Table } from "react-bootstrap";
import { fourPlaceHolder, getFullName } from "modules/utilities/utility";
function UsersCallProvider({
  callProvidersResponse,
  handleUserCallProviderFilter,
  handleToggleModal,
  userCallProvidersResponse,
  handleUpdateUserCallProviderDetails,
  searchLoading,
  setSearchLoading,
  isUserCallProviderLoading,
}) {
  const debouncedSearchFilter = useCallback(
    _.debounce(({ key, value }) => {
      handleUserCallProviderFilter({ key, value });
    }, 1000),
    [handleUserCallProviderFilter]
  );

  const { data, limit, page, totalCount } = userCallProvidersResponse;
  const totalPages = Math.ceil(totalCount / limit);
  const pagesToShow = totalPages > 5 ? 5 : Math.ceil(totalPages / 2);
  const startingIndex = (page - 1) * limit + 1;

  function handlePageChange(page) {
    handleUserCallProviderFilter({ key: "page", value: String(page) });
  }

  return (
    <div>
      <div className="d-flex flex-wrap justify-content-end gap-2">
        <Button
          type="primary"
          onClick={() => handleToggleModal({ type: "new" })}
        >
          Create User Call Provider
        </Button>
        <Input.Search
          suffix={
            searchLoading ? (
              <div
                className="spinner-border spinner-border-sm text-primary"
                role="status"
              ></div>
            ) : null
          }
          style={{ width: "200px" }}
          onChange={(event) => {
            setSearchLoading(true);
            debouncedSearchFilter({
              key: "search",
              value: event.target.value,
            });
          }}
          placeholder="Search"
          allowClear
        />
        <Select
          mode="multiple"
          placeholder="Select Call Provider"
          onChange={(value) =>
            handleUserCallProviderFilter({ key: "callProviderIds", value })
          }
          style={{ width: "170px" }}
          maxTagCount={0}
          allowClear
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {Array.isArray(callProvidersResponse?.data)
            ? callProvidersResponse?.data?.map((provider) => (
                <Select.Option key={provider?.id}>
                  {provider?.provider_name}
                </Select.Option>
              ))
            : null}
        </Select>
        <Select
          mode="single"
          placeholder="Select Next Call"
          onChange={(value) =>
            handleUserCallProviderFilter({ key: "nextCall", value })
          }
          style={{ width: "170px" }}
          maxTagCount={0}
          allowClear
        >
          <Select.Option key={true}>Yes</Select.Option>
          <Select.Option key={false}>No</Select.Option>
        </Select>
        <Select
          mode="single"
          placeholder="Select Active"
          onChange={(value) =>
            handleUserCallProviderFilter({ key: "isActive", value })
          }
          style={{ width: "170px" }}
          maxTagCount={0}
          allowClear
        >
          <Select.Option key={true}>Yes</Select.Option>
          <Select.Option key={false}>No</Select.Option>
        </Select>
        <span className="shadow p-2 text-nowrap text-center rounded-3">
          Results: {totalCount}
        </span>
      </div>
      <Table responsive className="mt-2">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email ID</th>
            <th>Provider</th>
            <th>External Agent ID</th>
            <th>Next Call</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {isUserCallProviderLoading
              ? Array.from({ length: 8 }, (_, index) => (
                  <td key={index}>{fourPlaceHolder()}</td>
                ))
              : null}
          </tr>
          {Array.isArray(data) &&
            data.map((user, index) => (
              <tr key={user?.user_call_provider_id}>
                <td>{startingIndex + index}</td>
                <td>{getFullName(user)}</td>
                <td>{user?.email}</td>
                <td>{user?.provider_name}</td>
                <td>{user?.external_agent_id || "-"}</td>
                <td>
                  <Popconfirm
                    title="Next Call"
                    description={`The user ${
                      user?.next_call
                        ? "will not have access to the 'Next Call' feature."
                        : "have access to the 'Next Call' feature."
                    }`}
                    onConfirm={() =>
                      handleUpdateUserCallProviderDetails({
                        key: "nextCall",
                        value: !user?.next_call,
                        userCallProviderId: user?.user_call_provider_id,
                      })
                    }
                    okText="Yes"
                    cancelText="No"
                  >
                    <Switch size="small" checked={user?.next_call} />
                  </Popconfirm>
                </td>
                <td>
                  <Popconfirm
                    title="Status"
                    description={`The user will ${
                      user?.is_active ? "not be able" : "be able"
                    } to place calls.`}
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() =>
                      handleUpdateUserCallProviderDetails({
                        key: "isActive",
                        value: !user?.is_active,
                        userCallProviderId: user?.user_call_provider_id,
                      })
                    }
                  >
                    <Switch size="small" checked={user?.is_active} />
                  </Popconfirm>
                </td>
                <td>
                  <Button
                    type="text"
                    shape="circle"
                    icon={<FaPencilAlt />}
                    onClick={() => handleToggleModal({ user, type: "edit" })}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {totalCount ? (
        <div className="d-flex justify-content-center my-2">
          <PaginationComponent
            currentPage={page}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            pagesToShow={pagesToShow}
          />
        </div>
      ) : null}
    </div>
  );
}

export default memo(UsersCallProvider);
